export default __webpack_public_path__ + "static/media/lineicons-alt.aa509be8.svg";